<mat-form-field class="autocomplete-country__field" appearance="outline">
  <mat-label>Country</mat-label>
  <input
    #countryInput
    matInput
    placeholder="Select a country"
    [matAutocomplete]="auto"
    [formControl]="countryControl()"
    (input)="search.set(countryInput.value)"
    (focus)="search.set(countryInput.value)"
  />
  <mat-autocomplete requireSelection autoActiveFirstOption #auto="matAutocomplete">
    @for (country of filteredCountries(); track country) {
      <mat-option class="autocomplete-country__option" [value]="country">
        {{ country }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
